import { supabase } from '@/integrations/supabase/client';

interface NotificationData {
  title: string;
  description?: string;
  assignedBy?: string;
  dueDate?: string;
  status?: string;
  approverName?: string;
}

type NotificationType = 'task_assigned' | 'task_due_soon' | 'approval_requested' | 'approval_resolved';

export async function sendNotification(
  type: NotificationType,
  recipientEmail: string,
  data: NotificationData,
  recipientName?: string
): Promise<{ success: boolean; error?: string }> {
  try {
    const response = await supabase.functions.invoke('send-notification', {
      body: {
        type,
        recipientEmail,
        recipientName,
        data
      }
    });

    if (response.error) {
      console.error('Error sending notification:', response.error);
      return { success: false, error: response.error.message };
    }

    return { success: true };
  } catch (error) {
    console.error('Error sending notification:', error);
    return { success: false, error: String(error) };
  }
}

export async function notifyTaskAssigned(
  recipientEmail: string,
  recipientName: string | null,
  taskTitle: string,
  taskDescription: string | null,
  assignedByName: string | null,
  dueDate: string | null
) {
  return sendNotification(
    'task_assigned',
    recipientEmail,
    {
      title: taskTitle,
      description: taskDescription || undefined,
      assignedBy: assignedByName || undefined,
      dueDate: dueDate ? new Date(dueDate).toLocaleDateString() : undefined
    },
    recipientName || undefined
  );
}

export async function notifyApprovalRequested(
  recipientEmail: string,
  recipientName: string | null,
  approvalTitle: string,
  approvalDescription: string | null
) {
  return sendNotification(
    'approval_requested',
    recipientEmail,
    {
      title: approvalTitle,
      description: approvalDescription || undefined
    },
    recipientName || undefined
  );
}

export async function notifyApprovalResolved(
  recipientEmail: string,
  recipientName: string | null,
  approvalTitle: string,
  status: 'approved' | 'rejected',
  approverName: string | null
) {
  return sendNotification(
    'approval_resolved',
    recipientEmail,
    {
      title: approvalTitle,
      status,
      approverName: approverName || undefined
    },
    recipientName || undefined
  );
}
